import { Box, Typography } from "@material-ui/core";
import React from "react";

import { InvestmentStyleDiagnosisRequestManagementStyleEnum as ManagementEnum } from "@/api/generated";
import {
  DIAGNOSIS_QUESTION_TEXT,
  MANAGEMENT_OPTIONS,
} from "@/constants/investmentStyleDiagnosisQuestions";

import { DiagnosisInvestmentStyleCheckboxList } from "../DiagnosisInvestmentStyleCheckboxList";

import { useStepStyles } from "./stepStyles";

type ManagementStepProps = {
  managementStyle: ManagementEnum | null;
  onManagementStyleChange: (next: ManagementEnum | null) => void;
};

const ManagementStep: React.FC<ManagementStepProps> = ({ managementStyle, onManagementStyleChange }) => {
  const classes = useStepStyles();
  return (
    <>
      <Typography className={classes.title}>購入後の運用への関わり方</Typography>
      <Typography className={classes.description}>{DIAGNOSIS_QUESTION_TEXT[9]}</Typography>
      <Box className={classes.notice}>
        <Typography className={classes.noticeText}>
          入居者対応や家賃管理などは、管理会社に任せることもできます。今の希望に最も近いものを選んでください。
        </Typography>
      </Box>
      <Box className={classes.inputArea}>
        <DiagnosisInvestmentStyleCheckboxList
          options={MANAGEMENT_OPTIONS}
          selected={managementStyle ? [managementStyle] : []}
          single
          onChange={(next) => onManagementStyleChange(next[0] ?? null)}
        />
      </Box>
    </>
  );
};

export default ManagementStep;
